import Grid from "@mui/material/Grid";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import PaymentsIcon from "@mui/icons-material/Payments";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import { StatCard } from "@/components/dashboard";
import type { AccountsDashboardStats } from "../types";

type AccountsMetricsProps = {
  stats: AccountsDashboardStats;
  showSabil: boolean;
  showLagat: boolean;
  showBooking: boolean;
  showNiyaaz: boolean;
  showYearlyNiyaaz: boolean;
};

export default function AccountsMetrics({
  stats,
  showSabil,
  showLagat,
  showBooking,
  showNiyaaz,
  showYearlyNiyaaz,
}: AccountsMetricsProps) {
  const totals = stats.totals ?? {};

  return (
    <Grid container spacing={{ xs: 1.5, sm: 2 }} sx={{ mb: { xs: 2, sm: 3 } }}>
      <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
        <StatCard
          title="Total collected"
          value={totals.all?.amount ?? 0}
          icon={AccountBalanceWalletIcon}
          color="primary"
          subtitle={`${totals.all?.count ?? 0} receipts`}
        />
      </Grid>
      {showSabil && (
        <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
          <StatCard
            title="Sabil receipts"
            value={totals.sabil?.amount ?? 0}
            icon={ReceiptLongIcon}
            color="success"
            subtitle={`${totals.sabil?.count ?? 0} receipts`}
          />
        </Grid>
      )}
      {showLagat && (
        <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
          <StatCard
            title="Lagat receipts"
            value={totals.lagat?.amount ?? 0}
            icon={ReceiptLongIcon}
            color="secondary"
            subtitle={`${totals.lagat?.count ?? 0} receipts`}
          />
        </Grid>
      )}
      {showBooking && (
        <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
          <StatCard
            title="Booking receipts"
            value={totals.booking?.amount ?? 0}
            icon={ReceiptLongIcon}
            color="warning"
            subtitle={`${totals.booking?.count ?? 0} receipts`}
          />
        </Grid>
      )}
      {showNiyaaz && (
        <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
          <StatCard
            title="Niyaaz event receipts"
            value={totals.niyaaz?.amount ?? 0}
            icon={ReceiptLongIcon}
            color="secondary"
            subtitle={`${totals.niyaaz?.count ?? 0} receipts`}
          />
        </Grid>
      )}
      {showYearlyNiyaaz && (
        <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
          <StatCard
            title="Yearly niyaaz receipts"
            value={totals.yearlyNiyaaz?.amount ?? 0}
            icon={ReceiptLongIcon}
            color="warning"
            subtitle={`${totals.yearlyNiyaaz?.count ?? 0} receipts`}
          />
        </Grid>
      )}
      <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
        <StatCard
          title="Cash"
          value={totals.cash?.amount ?? 0}
          icon={PaymentsIcon}
          color="success"
          subtitle={`${totals.cash?.count ?? 0} receipts`}
        />
      </Grid>
      <Grid size={{ xs: 6, sm: 6, md: 4, lg: 3, xl: 2 }}>
        <StatCard
          title="Bank / other"
          value={totals.bank?.amount ?? 0}
          icon={AccountBalanceIcon}
          color="primary"
          subtitle={`${totals.bank?.count ?? 0} receipts`}
        />
      </Grid>
    </Grid>
  );
}
